import {
    IWorkflowStatusManager
} from 'typings/manager';

export class ManagerCardWorkflowStatus implements IManagerCard {
    private _managerSourceId: string;
    private _displayName: string;
    private _jobTitleInternal: string;

    constructor(workflowStatusManagerDto: IWorkflowStatusManager) {
        this._managerSourceId = workflowStatusManagerDto.managerSourceId;
        this._displayName = workflowStatusManagerDto.displayName;
        this._jobTitleInternal = workflowStatusManagerDto.jobTitleInternal;
    }

    get managerSourceId(): string {
        return this._managerSourceId;
    }

    get displayName(): string {
        return this._displayName;
    }

    get jobTitleInternal(): string {
        return this._jobTitleInternal;
    }
}